import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-524f005a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-x3 xl:mb-x4" }
const _hoisted_2 = { class: "font-bold text-11 md:text12 mb-x2" }
const _hoisted_3 = { class: "sr-only" }
const _hoisted_4 = { class: "color-grid" }

import { CustomizerFacetViewModel } from '@/types/productServerApi';
import SearchFacetColorSwatch
    from '@/shared/product/customizer/ui/overlays/material-and-color/SearchFacetColorSwatch.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFacetColors',
  props: {
    facet: null
  },
  setup(__props: any) {




const labels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(labels).overlayColorFacetTitle), 1),
    _createElementVNode("fieldset", null, [
      _createElementVNode("legend", _hoisted_3, _toDisplayString(_unref(labels).overlayColorFacetTitle), 1),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.facet.options, (option, idx) => {
          return (_openBlock(), _createElementBlock("li", {
            key: option.value+idx
          }, [
            _createVNode(SearchFacetColorSwatch, { option: option }, null, 8, ["option"])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})